<template lang="pug">
#vform-container(v-loading="loading", element-loading-text="数据处理中...")
  v-form-designer(
    ref="vfDesigner",
    :setFieldList="setFieldList",
    :hiddenToken="hiddenToken",
    :globalDsv="globalDsv",
    :designer-config="designerConfig",
    @widget-name="updateWidgetName",
    v-if="setFieldList.length > 0",
    :key="vFormkey"
  )
    template(#customToolButtons)
      el-tooltip(placement="top", :content="formCode")
        .attr-item 表单编号：
          span(@click="formAttr") {{ formCode }}
      el-tooltip(placement="top", :content="tableCode")
        .attr-item 业务模型：
          span(@click="showDataTable") {{ tableCode }}
      .space-item
      el-button(type="text", icon="el-icon-view", @click="doCommand('$vformRef.previewForm')") 预览
      el-button(type="text", icon="el-icon-finished", @click="saveFormJson") 保存
      el-dropdown(size="small", @command="doCommand")
        el-button(type="text", icon="el-icon-more")
        template(#dropdown)
          el-dropdown-menu
            el-dropdown-item(icon="el-icon-upload2", command="$vformRef.importJson") 导入
            el-dropdown-item(icon="el-icon-download", command="$vformRef.exportJson") 导出
            el-dropdown-item(icon="el-icon-close", command="clearFormWidget") 清空
  el-dialog(v-draggable, width="1250px", title="业务模型", :visible.sync="visible", :close-on-click-modal="false")
    div(style="height: 600px; overflow: auto")
      meta-page(ref="matePage", :is-read="true")
  editFormDialog(ref="editFormDialog", isView)
</template>

<script>
import metadataService from "@/CommonDP/service/metadata-service.js";
import { widgetListMap, formConfig } from "./formMlib/index";
import { getToken } from "@/CommonDP/utils";
import { mapState } from "vuex";
import { Grid, itemColumnsMap, itemSubmitMap } from "@/CommonDP/VForm/utils";
import metaPage from "@/CommonDP/pages/mainMg/lowcode/metadata/component/metaPage/metaPage.vue";
import editFormDialog from "../metadata/component/dialog/editFormDialog.vue";
import { get } from "lodash-es";
import Prop from "./formSettingProp.vue";
import EventSetting from "./formSettingEvent.vue";
export default {
  name: "VformDesigner",
  components: { metaPage, editFormDialog },
  data() {
    return {
      designerConfig: {
        languageMenu: false,
        clearDesignerButton: false,
        generateSFCButton: false,
        exportJsonButton: false,
        exportCodeButton: false,
        importJsonButton: false,
        previewFormButton: false,
        formSettingPanel: { prop: Prop , event: EventSetting}
      },
      vFormkey: 0,
      nodeData: {},
      loading: false,
      setFieldList: [], // 默认的文件id,表单的唯一标识
      hasFormJson: "", // 是否设计好json
      metaData: [], // 使用当前数据模型的所有数据
      layoutType: 1, // 默认布局样式为 几栏
      modelId: "", // 业务模型id
      subformFieldList: [],
      prevTableName: "",
      visible: false
    };
  },
  provide() {
    return {
      setFieldList: () => this.setFieldList
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    formCode() {
      return this.nodeData.formCode;
    },
    tableCode() {
      const { setFieldList } = this;
      return setFieldList[0]?.tableName;
    },
    $vformRef() {
      return this.$refs.vfDesigner;
    },
    hiddenToken() {
      return "Bearer " + getToken();
    },
    formId() {
      return this.nodeData.groupId;
    },
    globalDsv() {
      return {
        appApi: process.env.VUE_APP_API,
        enterpriseId: this.enterpriseId,
        formId: this.formId,
        token: this.hiddenToken,
        flowModeStatus: "initiate", // 默认发起状态
        flowInstanceId: "" // 设计时流程id为空
      };
    }
  },
  methods: {
    // 处理对应数据
    doCommand(fnKey) {
      const fn = get(this, fnKey);
      fn && Reflect.apply(fn, this, []);
    },
    // 获取表单对应的业务模型数据
    async getcolumnList(data) {
      this.vFormkey++;
      this.layoutType = data.layoutType || 1;
      this.loading = true;
      this.nodeData = { ...data };
      this.hasFormJson = await this.queryDynFormJson(data.formCode);
      this.setFieldList = [];
      const res = await metadataService.formDetails(data.groupId);
      this.metaData = res.data;
      this.setFieldList = this.metaData.map((e) => {
        return {
          tableName: e.tableName,
          maxLength: ~~e.displayDataLength,
          label: e.columnDisplayName,
          name: e.columnName
        };
      });
      await this.$nextTick();
      if (this.hasFormJson) {
        this.hasFormJson.formConfig = {
          ...formConfig,
          ...this.hasFormJson.formConfig
        };
        this.$vformRef.setFormJson(this.hasFormJson);
      } else {
        this.dealFormData();
      }
      this.loading = false;
    },
    updateWidgetName(widget, options) {
      let item;
      switch (widget.type) {
        case "input":
        case "textarea":
          item = options.find(({ name }) => widget.options.name === name);
          if (item?.maxLength) {
            widget.options.maxLength = item.maxLength;
          }
          break;
      }
    },
    // 查询是否有json 数据
    async queryDynFormJson(formCode) {
      const res = await metadataService.queryDynFormAllInfoByFormCode(formCode);
      return JSON.parse(res.data.json) || "";
    },
    // 默认表单的json数据
    async dealFormData() {
      const { metaData } = this;
      const widgetList = [];
      for (const data of metaData) {
        if (data.isInternalField === 1) continue;
        const schema = widgetListMap(data);
        widgetList.push(schema);
      }
      const items = new Grid(this.layoutType, widgetList);
      const formJson = {
        widgetList: items.data,
        formConfig
      };
      this.$vformRef.setFormJson(formJson);
    },
    // 获取所有字段组件
    getFieldWidgets() {
      return this.$vformRef.getFieldWidgets();
    },
    // 保存表单 按钮功能
    async saveFormJson() {
      const formJson = this.$vformRef.getFormJson();
      const params = await this.formatJson(formJson);
      await metadataService.dynFormDesignSave(params);
      this.$message.success("表单已保存！");
      this.$emit("initTree");
    },
    // 格式化json数据，对子表单做处理
    async formatJson(form) {
      const flats = [...form.widgetList];
      const dataPlus = {};
      let slaveTableList = [];
      const loadedTypes = new Set();
      const typeFn = {};
      for (const item of flats) {
        const { type } = item;
        item.widgetList?.length && flats.push(...item.widgetList);
        item.tabs?.length && flats.push(...item.tabs);
        item.cols?.length && flats.push(...item.cols);
        const isLoad = loadedTypes.has(type);
        if (!isLoad) {
          loadedTypes.add(type);
          const submitKeys = itemSubmitMap[type];
          if (submitKeys) {
            const keys = Object.keys(submitKeys);
            for (const key of keys) {
              dataPlus[key] = [];
            }
            typeFn[type] = (item) => {
              for (const key of keys) {
                const d = submitKeys[key](item);
                d && dataPlus[key].push(d);
              }
            };
          }
        }
        typeFn?.[type]?.(item);
      }

      // 对关联子表单的处理
      const list = flats.filter((e) => e.type === "custom-sub-form" || (e.type === "jyht-table" && e.options.sublist));
      if (list.length) {
        slaveTableList = await this.getSlavetableList(list);
      }
      const customSubFormContainerList = this.$vformRef.getContainerWidgets()?.filter((e) => e.type === "custom-sub-form") || [];
      const customSubFormList = customSubFormContainerList.map((e) => {
        const {
          id,
          options: { label, name, sublist, fieldNum, disabled, hidden, required }
        } = e.container;
        const data = {
          name,
          id,
          type: e.type,
          label,
          sublist,
          fieldNum,
          disabled,
          hidden,
          required
        };
        return data;
      });

      // 对字段处理 formColumns
      const fieldWidgets = this.getFieldWidgets().map((e) => {
        const { label, readonly, remark, required, disabled, hidden, defaultValue, maxLength, minLength, format, valueFormat } = e.field.options;
        const data = {
          name: e.name,
          id: e.field.id,
          type: e.type,
          label,
          readonly,
          remark,
          required,
          disabled,
          hidden,
          defaultValue,
          maxLength,
          minLength,
          format,
          valueFormat
        };
        // 处理组件自定义的fieldWidgets提交字段
        const columnFn = itemColumnsMap[e.type];
        if (columnFn) {
          const columnPlus = columnFn?.(e.field.options);
          Object.assign(data, columnPlus);
        }
        return data;
      });
      for (const customSubForm of customSubFormList) {
        const prefix = customSubForm.sublist + "_" + customSubForm.fieldNum;
        for (const element of fieldWidgets) {
          if (element.name?.startsWith(prefix)) {
            element.parentContainer = customSubForm.name;
          }
        }
      }
      const formColumns = fieldWidgets.concat(customSubFormList);
      const json = {
        formId: this.formId,
        json: JSON.stringify(form),
        ...dataPlus,
        slaveTableList,
        formColumns
      };
      return json;
    },
    // 有关联子表单的对应子表数据
    async getSlavetableList(list) {
      return list.map((e) => {
        const {
          options: { name: slaveTableField, sublist: slaveTableName, fieldNum },
          type
        } = e;
        return {
          slaveTableField,
          slaveTableName,
          fieldNum: fieldNum || Math.floor(Math.random() * 100000),
          widgetType: type
        };
      });
    },
    // 清空表单 按钮功能
    async clearFormWidget() {
      await this.$confirm("清空后会默认使用业务模型数据,已设计好的会被表单永久删除，请确认?", "提示", {
        type: "warning"
      });
      await metadataService.dynFormDesignDelete(this.nodeData.groupId);
      this.$vformRef.clearDesigner();
      this.$success("清空成功");
      this.$emit("initTree");
    },
    // 业务模型 按钮功能
    async showDataTable() {
      const res = await metadataService.getFormRelatedTable(this.nodeData.groupId);
      const nodeData = res.data;
      nodeData.groupName = nodeData.businessName;
      nodeData.groupId = nodeData.tableName;
      nodeData.remark = nodeData.tableDesc;
      this.visible = true;
      await this.$nextTick();
      this.$refs.matePage.getcolumnList(nodeData);
    },
    // 表单属性 按钮功能
    async formAttr() {
      const { data } = await metadataService.getFormIdDetail(this.nodeData.groupId);
      data && this.$refs.editFormDialog.editForm(data);
    }
  }
};
</script>

<style scoped>
@import "~@/CommonDP/lib/vform/VFormDesigner.css";
</style>
<style lang="scss" scoped>
#vform-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  /deep/ {
    .main-header {
      display: none;
    }
    .main-container {
      margin-left: 0 !important;
    }
    .toolbar-header {
      display: flex;
      flex-flow: row nowrap;
    }
    .toolbar-container {
      overflow: hidden;
      height: 100%;
      flex-grow: 1;
    }
    .right-toolbar {
      height: 100%;
    }
    .right-toolbar-con {
      display: flex !important;
      height: 100%;
      align-items: center;
      margin-left: 8px;
      > .space-item {
        flex: 1 1 auto;
      }
      > .attr-item {
        margin-left: 4px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        > span {
          cursor: pointer;
          color: #658deb;
          &:hover {
            filter: brightness(1.2);
          }
        }
      }
    }
    .left-aside-toggle-bar {
      padding-top: 10px !important;
    }
    .right-aside-toggle-bar {
      padding-top: 8px !important;
    }
    .el-form-item {
      margin-bottom: 10px;
    }
  }
}
</style>
<style lang="scss">
.ace_editor,
.ace_editor * {
  font-family: "Monaco", "Menlo", "Ubuntu Mono", "Droid Sans Mono", "Consolas", monospace !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  letter-spacing: 0 !important;
}

.ace-sqlserver .ace_print-margin {
  width: 0px;
}
</style>
